import { IonContent, IonPage, IonCol, IonRow, IonGrid, isPlatform, IonImg, useIonViewDidEnter } from '@ionic/react';
import React from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './InstallAppInstructionsPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { useHistory } from 'react-router-dom';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';

const InstallAppInstructionsPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();

  useIonViewDidEnter(() => {
      // making typescript happy
      const windowNavigator: any = window.navigator;
      // check to see if app installed on ios or android
      if(windowNavigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
        history.push(AppRouteInfo[AppRouteKeys.Home].path, {direction: 'forward'});
      }
  });

  let instructionGifUrl = 'https://biblestudytogether.com/wp-content/uploads/2020/12/bst-install-android.gif';
  let instructionGifUrl2 = '';

  let instructionText = <div className="install-instructions-mobile">Follow the instructions below:</div>;

  if(!isPlatform('hybrid')){

    if(isPlatform('ios')){
      instructionText = <div className="install-instructions-mobile">
        <p>We recommend you install the version of this app from the Apple App Store by going here:<br />
        <a rel="noreferrer" target="_blank" href="https://apps.apple.com/app/id1331946347">Get Bible Study Together App</a></p>
        <p>If you don't want to install the app from the app store you can follow the instruction below to install the web app version (PWA).</p>
        <p className="ios-install-app-warning"><b>NOTE:</b> If you do not install the app from the App Store, iOS devices may delete this app's 
        stored data if your device becomes completely full of images, 
        videos, and music. Therefore, leave some extra storage space on your device and you won't have any problems.</p>
          <p>Follow the instructions below:</p></div>;
      if(isPlatform('iphone')){
        instructionGifUrl = 'https://biblestudytogether.com/wp-content/uploads/2020/12/bst-install-iphone.gif';
      } else if(isPlatform('ipad')) {
        instructionGifUrl = 'https://biblestudytogether.com/wp-content/uploads/2020/12/bst-install-ipad.gif';
      }
    } else if(isPlatform('android')) {
      instructionGifUrl = 'https://biblestudytogether.com/wp-content/uploads/2020/12/bst-install-android.gif';
      // Let people know to use chrome
      console.log(/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));

      const samsungInstructionText = <div className="install-instructions-mobile">
        <p><a rel="noreferrer" target="_blank" href="https://play.google.com/store/apps/details?id=net.synergyts.bst">Get our App here<br />from the Google Play Store.</a></p>
        <p>Or open the Google Chrome Web Browser App. Go to https://app.BibleStudyTogether.com. Follow the instructions below:</p></div>;

      const googlePlayInstructionText = <div className="install-instructions-mobile"><p>You can install the web version of our app on your home screen by following the instruction below or by downloading the app form the Google Play App Store.</p>
      <p><a rel="noreferrer" target="_blank" href="https://play.google.com/store/apps/details?id=net.synergyts.bst">Get our App here<br />from the Google Play Store.</a></p></div>;

      const amazonFireInstructionText = <div className="install-instructions-mobile">
        <p>You can install the Bible Study Together App from the Amazon App store by going here:</p>
        <p><a rel="noreferrer" target="_blank" href="https://www.amazon.com/gp/product/B09NMVVH43/ref=mas_pm_bible_study_together">Get our App here from the Amazon App Store.</a></p> 
        <p>If you device has the Google Chrome Web Browser App, you can follow the instructions below to install the web version of our app.</p></div>;

      instructionText = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !navigator.userAgent.match(/SamsungBrowser/i) ? 
          googlePlayInstructionText : 
        navigator.userAgent.match(/SamsungBrowser/i) ? 
          samsungInstructionText:
        navigator.userAgent.match(/Silk/) ?
          amazonFireInstructionText :
          googlePlayInstructionText
        ;
    } else {
      console.log('desktop');
      instructionGifUrl = 'https://biblestudytogether.com/wp-content/uploads/2023/12/pwa-install-chrome.png';
      instructionGifUrl2 = 'https://biblestudytogether.com/wp-content/uploads/2020/12/install-on-desktop-chrome.jpg';
      instructionText = <div className="install-instructions-desktop">Bible Study Together is a PWA and can be installed from your browser. Most browsers should display an install icon on the right side of the page search bar as seen below. This icon will look different based on the browser you are using. If you are having trouble installing the web app we recommend creating a bookmark or favorite in your web browser. Most browsers are pretty similar on how to do this, but using Chrome you can follow the picture instructions below:</div>;
    }
  }

  return (
    <IonPage>
      <PageHeader {...props} ></PageHeader>
      <IonContent>
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>    
              {instructionText}
              <IonImg className="animated-install-gif" src={instructionGifUrl} /><br />
              {instructionGifUrl2 && <IonImg className="animated-install-gif" src={instructionGifUrl2} /> }
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default InstallAppInstructionsPage;